import { render, staticRenderFns } from "./PastPapers.vue?vue&type=template&id=4816003f&"
import script from "./PastPapers.vue?vue&type=script&lang=ts&"
export * from "./PastPapers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports